type Command = Function | Record<string, Function>;

export interface ICommandLineInterface {
    addCommand: (name: string, command: Command) => void;
    removeCommand: (name: string) => void;
}
